import { App } from "vue";

import { router } from "frontend/router";

export function setupRouter(app: App<Element>): void {
  app.use(router);
}
